import PriceMixin from '@/../shared/mixins/price'

export default {
  mixins: [PriceMixin],
  data () {
    return {
      metadataProducts: []
    }
  },
  methods: {
    updateMetadataProducts (hits) {
      this.metadataProducts = hits.map(this.metadataProduct)
    },
    metadataProduct (hit) {
      return {
        "@type": "Product",
        "brand": {
          "@type": "Brand",
          "name": hit.supplier?.name
        },
        "name": hit.proper_name,
        "image": hit.main_image,
        "offers": {
          "@type": "Offer",
          "price": hit.price_show,
          "priceCurrency": "USD",
          "availability": `http://schema.org/${this.metadataAvailability(hit)}`
        }
      }
    },
    metadataAvailability (hit) {
      if (hit.no_available) return 'Discountinued'
      if (hit.in_stock) return 'InStock'

      return 'BackOrder'
    }
  }
}